export default __webpack_public_path__ + "static/media/exclude.260ab73e.svg";